const styles = (theme) => ({
  listItem: {
    fontWeight: 300,
    fill: theme.palette.text.primary,
    color: theme.palette.text.primary,

    paddingRight: theme.spacing(1),

    '&.Mui-selected': {
      background: 'inherit',
      fill: theme.palette.primary.red,
      color: theme.palette.primary.red,
    },

    '&.MuiListItem-button:hover': {
      background: 'inherit',
      fill: theme.palette.primary.red,
      color: theme.palette.primary.red,
    },
  },
  listItemIcon: {
    fill: 'currentColor',
    color: 'currentColor',
    justifyContent: 'center',
    paddingRight: theme.spacing(1),
    minWidth: '34px',
  },
  icon: {
    maxWidth: 20,
    maxHeight: 20,
    width: '100%',
    height: '100%',
  },
  roomLoading: {
    height: '10px',
    padding: '0 16px',
    marginBottom: '20px',
  },
  divider: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.primary.whiteDark,
  },
  boligmappaLogo: {
    width: '100%',
    height: '100%',
    maxWidth: '1.8rem',
    maxHeight: '1.8rem',
  },
});

export default styles;
